import PuzzleService from '_services/rest/modules/puzzle';

export default {
  state: {
    letrex: null,
    hasChanges: false,
  },
  mutations: {
    setLetrex(state, letrex) {
      state.letrex = letrex;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
  },
  actions: {
    setLetrex({ commit }, model) {
      commit('setLetrex', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    getLetrex({ commit }, id) {
      PuzzleService.getPuzzleById(id).then(response => {
        commit('setLetrex', response);
        commit('setHasChanges', false);
      });
    },
  },
};
